// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qBKp","type":"styles_type__23fjZ","choices":"styles_choices__3MMQz"};